import _ from 'lodash'


export const URLHash = {
    parse: function(path) {
        if (_.startsWith(path, '#')) {
            path = path.slice(1)
        }

        const parts = path.split('/')
        return _(parts).map(Segment.parse.bind(Segment)).filter().value()
    },

    clear: function() {
        window.location.hash = ''
    }
}


export let Segment = {
    new: function(type, identifier) {
        return {
            type: type,
            identifier: identifier,

            serialize: function() {
                return type + '.' + identifier
            }
        }
    },

    parse: function(segment) {
        let [type, identifier] = segment.split('.')

        if (_.isNil(type) || _.isNil(identifier) || type === '' || identifier === '') {
            return null
        }

        return this.new(type, identifier)
    }
}


let store = null
let routes = {}

export let Router = {
    initialize: function(newStore, newRoutes) {
        store = newStore
        routes = newRoutes

        window.addEventListener('hashchange', () => {
            this.checkHash()
        })

        _.bindAll(this, 'checkHash')
    },

    loadCurrentHash: function() {
        if (window.location.hash === '' || window.location.hash === '#') {
            URLHash.clear()
            return
        }

        this.load(window.location.hash)
    // this.clear();
    },

    load: function(path) {
        const segments = URLHash.parse(path)

        _.each(segments, (segment) => {
            _.invoke(routes, segment.type, store, segment)
        })
    },

    clear: function() {
        URLHash.clear()
    },

    external: function(url) {
        window.location.href = url
    },

    checkHash: function() {
        this.loadCurrentHash()
    }
  
}
